const SERVICE_IDENTIFIERS = {
    SOCKET: Symbol('Socket'),
    AUTH: Symbol('Auth'),
};

export default SERVICE_IDENTIFIERS;
